<template>
  <!-- 责任核定 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit('SAVE')">保存</el-button>
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit('POSTING')">保存并过账</el-button>
    </div>
    <div class="formbox">
      <el-form :model="baseInForm" :rules="rules" ref="baseInFormRef" label-width="110px" class="glo_formBox">
        <!-- <el-form-item label="异常编号:" prop="number">
          <el-input v-model="number" placeholder="自动带出" disabled></el-input>
        </el-form-item>-->
        <el-form-item label="核定人:" prop="handleUserId" style="width: 320px">
          <el-select v-model="baseInForm.handleUserId" placeholder="请选择" @change="changeUser">
            <el-option v-for="item in employeeList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核定时间:" prop="handleTime" style="width: 320px">
          <el-date-picker v-model="baseInForm.handleTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <div class="uploadBox" style="width: 100%">
          <div class="uploadItem">
            <div class="uploadLaber" style="margin-right: 10px">核定图片:</div>
            <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="9"></uploadimgs>
          </div>
        </div>

        <el-form-item class="textArea" style="width: 100%" label="核定描述:" prop>
          <el-input type="textarea" rows="3" placeholder="请输入" v-model="baseInForm.handleDescribe"></el-input>
          <!-- <div id="eidtContent_zh-CN"></div> -->
        </el-form-item>
        <el-form-item label="赔款金额:" prop>
          <el-input v-model="indemnityAmount" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建人:" prop="aaa" style="width: 320px">
          <el-input v-model="createUserName" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间:" prop="aaa" style="width: 320px">
          <el-input v-model="createTime" placeholder="自动带出" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="glo_Table" style="margin-bottom: 20px">
      <div class="h3title">
        <div class="titles">责任核定</div>
        <div class="iconBox">
          <el-button class="glo_bgcMainColor" @click="addIcon()">添加责任人</el-button>
        </div>
      </div>
      <el-table :data="tableData2" v-if="tableData2" border style="width: 100%">
        <el-table-column align="center" prop label="责任对象" width="300px">
          <template slot-scope="scope">
            <div class="twoInput">
              <!-- 结算对象类型 -->
              <el-select v-model="tableData2[scope.$index].objectStatusConfDictId" placeholder="请选择" @change="changeObjestStatusYS($event, scope.$index)" clearable>
                <el-option v-for="item in objectStatusList" :key="item.confDictId" :label="item.val" :value="item.confDictId"></el-option>
              </el-select>
              <!-- 结算对象 -->
              <el-select v-model="tableData2[scope.$index].objectName" clearable filterable allow-create @change="changeobjectName1($event, scope.$index)" placeholder="请选择">
                <el-option v-for="(item, index) in tableData2[scope.$index]
                    .CustomerListsYF" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="责任比例">
          <template slot-scope="scope">
            <el-input v-model="tableData2[scope.$index].dutyRatio" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="责任金额">
          <template slot-scope="scope">
            <el-input v-model="tableData2[scope.$index].amount" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="付款方式">
          <template slot-scope="scope">
            <el-select v-model="tableData2[scope.$index].paymentMethodConfDictId" clearable placeholder="请选择">
              <el-option v-for="item in settlement_methodList" :key="item.confDictId" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="收支类型">
          <template slot-scope="scope">
            <el-select v-model="tableData2[scope.$index].inoutStatus" clearable placeholder="请选择">
              <el-option v-for="(item, index) in inoutStatusList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="是否生成财务单据">
          <template slot-scope="scope">
            <el-select v-model="tableData2[scope.$index].isFinance" clearable placeholder="请选择">
              <el-option v-for="item in isFinanceList" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="备注">
          <template slot-scope="scope">
            <el-input v-model="tableData2[scope.$index].remarks" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="操作">
          <template slot-scope="scope">
            <i style="font-size: 30px; margin-left: 10px" class="el-icon-delete" @click="delIcon(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-checkbox v-model="checked" style="margin-top:16px;">产生车辆成本</el-checkbox>
      <div class="h3title" style="margin-top:16px;" v-if="checked">
        <div class="titles">车辆核定</div>
        <div class="iconBox">
          <el-button class="glo_bgcMainColor" @click="addIcon1()">添加车辆</el-button>
        </div>
      </div>
      <el-table :data="tableData1" v-if="tableData1 && checked" border style="margin-top:16px;width: 100%;">
        <el-table-column align="center" prop label="责任对象" width="300px">
          <template slot-scope="scope">
            <!-- 结算对象类型 -->
            <el-select
              v-model="tableData1[scope.$index].objectNumber"
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethcarNumberList(e,scope.$index);
                }
              "
              @focus="
                (e) => {
                  focusMethodcarNumberList(scope.$index);
                }
              "
              @change="
                (e) => {
                  changeMethodcarNumberList(e,scope.$index);
                }
              "
              @clear="remoteMethcarNumberList('',scope.$index)"
              placeholder="请选择"
              clearable
            >
              <el-option v-for="(item,index) in tableData1[scope.$index].carNumberList" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="金额">
          <template slot-scope="scope">
            <el-input v-model="tableData1[scope.$index].amount" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="付款方式">
          <template slot-scope="scope">
            <el-select v-model="tableData1[scope.$index].paymentMethodConfDictId" clearable placeholder="请选择">
              <el-option v-for="item in settlement_methodList" :key="item.confDictId" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="收支类型">
          <template slot-scope="scope">
            <el-select v-model="tableData1[scope.$index].inoutStatus" clearable placeholder="请选择">
              <el-option v-for="(item, index) in inoutStatusList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="备注">
          <template slot-scope="scope">
            <el-input v-model="tableData1[scope.$index].remarks" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop label="操作">
          <template slot-scope="scope">
            <i style="font-size: 30px; margin-left: 10px" class="el-icon-delete" @click="delIcon1(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
// import E from "wangeditor";
import { type } from "os";
export default {
  inject: ["reload"],
  components: { uploadimgs },
  data() {
    return {
      indemnityAmount: "",
      createUserName: "",
      createTime: "",
      checked: false,
      baseInForm: {
        handleUserName: "",
        handleUserId: "",
        handleTime: "",
        handleDescribe: "",
        fileIds: [],
      },
      number: "",
      contents: {
        content: "",
        title: "",
        editor: {},
      },
      fileNameLists: [],
      fileNameLists2: [],

      rules: {
        handleTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        handleUserId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      CustomerList: [],
      tableData2: [],

      employeeList: [],
      userNames: "", //登录账号的员工

      objectStatusList: [],
      settlement_methodList: [],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      isFinanceList: [
        {
          name: "是",
          val: 1,
        },
        {
          name: "否",
          val: 0,
        },
      ],

      DelTableData2: [], //已经删除的责任对象
      DelTableData2_2: [], //已经删除的责任对象
      pageType: "",

      tableData1: [],
      carNumberList: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.initLangeuage();
    // });
    this.getObjectUserDownLists("employee");
    this.getConfDictValDownList("object_status");
    this.getConfDictValDownList("settlement_method"); //付款方式

    let UserInfo = this.$TOOLS.getUserInfo() || "";
    if (UserInfo && UserInfo.employeeName) {
      console.log("UserInfo", UserInfo);
      this.userNames = UserInfo.employeeName;
    }
  },
  activated() {
    let exceptionId = this.$route.query.exceptionId || "";
    this.pageType = this.$route.query.pageType || "";
    let number = this.$route.query.number || "";
    let { createUserName, createTime, indemnityAmount } = this.$route.query;
    this.createTime = createTime;
    this.createUserName = createUserName;
    this.indemnityAmount = indemnityAmount;
    if (exceptionId) {
      this.exceptionId = exceptionId;
      this.number = number;

      this.$API
        .getExceptionDutyDetail({ exceptionId: exceptionId })
        .then((res) => {
          console.log(res, "res");

          let result = res.data.result || "";
          let datas = [];
          let fileVos = [];
          if (result) {
            if (this.pageType == "zrhd") {
              this.baseInForm = result;
              console.log("this.baseInForm", this.baseInForm);
            }
          }
          if (result && result.dutyVos) {
            datas = res.data.result.dutyVos || [];
          }
          if (result && result.fileVos) {
            fileVos = res.data.result.fileVos || [];
          }

          datas.forEach((item) => {
            item.operationType = "UPDATE";
          });
          this.tableData2 = datas;

          if (result && result.carCostVos) {
            let carCostVos = result.carCostVos || [];
            if (carCostVos.length) {
              carCostVos.forEach((item) => {
                item.operationType = "UPDATE";
              });
              this.checked = true;
              this.tableData1 = carCostVos;
            }
          }

          let arrs = [];
          fileVos.forEach((item) => {
            arrs.push({
              name: item.fileId,
              url: item.fileUrl,
              operationType: "UPDATE",
            });
          });
          this.fileNameLists = arrs;
          this.fileNameLists2 = arrs.map((item) => {
            return item.name;
          }); //记录原来的
        });
      if (this.pageType !== "zrhd") {
        this.getDetails();
      }
    }
  },
  destroyed() {},
  methods: {
    focusMethodcarNumberList(index) {
      if (this.tableData1[index].carNumberList.length == 0) {
        this.remoteMethcarNumberList("", index);
      }
    },
    changeMethodcarNumberList(e, index) {
      // if (e) {
      //   let curs = this.tableData1[index].carNumberList.filter(
      //     (item) => item.carId == e
      //   )[0];
      // }
      this.tableData1[index].carNumberList.objectName = e;
    },
    remoteMethcarNumberList(carNumber, index) {
      this.$API
        .CarDownList({
          pageStart: 1,
          pageTotal: 20,
          carNumber,
        })
        .then((res) => {
          this.tableData1[index].carNumberList = res.data.result.data || [];
        });
    },
    // 新建责任对象
    addIcon1(idx) {
      let datas = JSON.parse(JSON.stringify(this.tableData1)) || [];
      let objs = {
        amount: "",
        inoutStatus: "",
        objectName: "",
        objectNumber: "",
        operationType: "ADD",
        paymentMethodConfDictId: "",
        remarks: "",
        CustomerListsYF: [],
        carNumberList: [],
      };
      datas.push(objs);
      this.tableData1 = datas;
    },
    // 删除责任对象
    delIcon1(idx) {
      this.$confirm("是否删除该责任对象", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData1)) || [];

          if (datas[idx].operationType !== "ADD") {
            datas[idx].operationType = "DEL";
            this.DelTableData2_2.push(datas[idx]);
          }
          datas.splice(idx, 1);
          this.tableData1 = datas;
        })
        .catch(() => {});
    },
    // 新建责任对象
    addIcon(idx) {
      let datas = JSON.parse(JSON.stringify(this.tableData2)) || [];
      let objs = {
        amount: "",
        dutyId: "",
        dutyRatio: "",
        inoutStatus: "",
        isFinance: 1,
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        operationType: "ADD",
        paymentMethodConfDictId: "",
        remarks: "",
        CustomerListsYF: [],
        objectStatusType: "",
      };
      datas.push(objs);
      this.tableData2 = datas;
    },
    // 删除责任对象
    delIcon(idx) {
      this.$confirm("是否删除该责任人", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData2)) || [];

          if (datas[idx].operationType !== "ADD") {
            datas[idx].operationType = "DEL";
            this.DelTableData2.push(datas[idx]);
          }
          datas.splice(idx, 1);
          this.tableData2 = datas;
        })
        .catch(() => {});
    },
    getObjectUserDownLists(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "employee") {
          // 获取员工列表
          this.employeeList = res || [];
          console.log(" this.employeeList ", this.employeeList);

          if (this.userNames) {
            this.employeeList.forEach((item) => {
              if (item.name === this.userNames) {
                console.log("this.userNames ", this.userNames);
                this.baseInForm.handleUserId = item.documentId;
                this.baseInForm.handleUserName = item.name;
                this.userNames = "";
              }
            });
          }
        }
      });
      // this.$COMAPI.getObjectUserDownList("employee").then(res=>{}); //获取员工列表
      // this.$COMAPI.getObjectUserDownList("dept").then(res=>{}); //获取部门列表
      // this.$COMAPI.getObjectUserDownList("storage").then(res=>{}); //获取网点列表
    },
    // 字典类型
    getConfDictValDownList(key) {
      this.$COMAPI.getConfDictValDownList(key).then((res) => {
        if (key == "exception_type") {
          //异常类型
          this.exception_type_list = res || [];
        }
        if (key == "object_status") {
          // 获取结算对象类型
          this.objectStatusList = res;
        }
        if (key == "settlement_method") {
          // 付款方式
          this.settlement_methodList = res;
        }
      });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name, idx) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.tableData2[idx].objectStatusType,
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let tableData2 = JSON.parse(JSON.stringify(this.tableData2));
          tableData2[idx].CustomerListsYF = res.data.result.data || [];
          this.tableData2 = tableData2;
          // this.tableData2[idx].CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName1(e, idx) {
      if (!e) {
        this.getObjectUserDownListYf("", idx);
        this.tableData2[idx].objectNumber = "";
      } else {
        this.tableData2[idx].CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.tableData2[idx].objectNumber = item.number;
          }
        });
      }
    },
    // 选择结算对象类型(应收
    changeObjestStatusYS(e, idx) {
      this.tableData2[idx].objectName = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.tableData2[idx].objectStatusType = item.key;
          }
        });
        //
        this.getObjectUserDownListYf("", idx);
      } else {
        this.tableData2[idx].objectName = "";
        this.tableData2[idx].objectNumber = "";
        this.tableData2[idx].objectStatusConfDictId = "";
      }
    },
    changeUser(e) {
      if (e) {
        this.employeeList.forEach((item) => {
          if (item.documentId == e) {
            this.baseInForm.handleUserName = item.name;
          }
        });
      } else {
        this.getCarrierList();
        this.baseInForm.handleUserName = "";
      }
    },
    // 责任核定
    submit(type) {
      let tableData = JSON.parse(JSON.stringify(this.tableData2));
      let deltableData = JSON.parse(JSON.stringify(this.DelTableData2));
      let tableData1 = JSON.parse(JSON.stringify(this.tableData1));
      let deltableData_1 = JSON.parse(JSON.stringify(this.DelTableData2_2));

      if (tableData.length == 0) {
        this.$message.error("核定对象不能为空");
        return false;
      }
      if (tableData1.length == 0 && this.checked) {
        this.$message.error("核定车辆不能为空");
        return false;
      }
      let fileNameLists = JSON.parse(JSON.stringify(this.fileNameLists));
      let fileNameLists2 = this.fileNameLists2; //原来的图片
      let fileIds = fileNameLists.map((item) => {
        return item.name;
      });

      // [1,2,3,4]   [1,3,4,5]
      let addList = [];
      let delList = [];
      fileNameLists.forEach((item) => {
        item.operationType = "UPDATE";
        if (fileNameLists2.indexOf(item.name) == -1) {
          // 找新增的
          item.operationType = "ADD";
          // addList.push(item);
        }
      });
      console.log("fileNameLists2", fileNameLists2);
      console.log("fileIds", fileIds);
      fileNameLists2.forEach((item2) => {
        if (fileIds.indexOf(item2) == -1) {
          console.log("这个是删除啊啊啊", item2);
          // 找删除的
          delList.push({
            name: item2,
            operationType: "DEL",
          });
        }
      });
      console.log("delList", delList);
      fileNameLists = [...fileNameLists, ...delList];
      let ids = fileNameLists.map((item) => {
        let objs = {
          fileId: item.name,
          operationType: item.operationType,
        };
        return objs;
      });
      // let describe = this.contents.editor.txt.html();
      tableData = [...tableData, ...deltableData];
      tableData.forEach((item) => {
        delete item.CustomerListsYF;
        delete item.objectStatusType;
      });
      tableData1.forEach((item) => {
        delete item.carNumberList;
      });
      tableData1 = [...tableData1, ...deltableData_1];

      let param = {
        dutyReqs: tableData,
        carCostReqs: tableData1,
        fileIds: ids || [],
        exceptionId: this.exceptionId || "",
        handleDescribe: this.baseInForm.handleDescribe || "",
        handleTime: this.baseInForm.handleTime || "",
        handleUserId: this.baseInForm.handleUserId || "",
        handleUserName: this.baseInForm.handleUserName || "",
        operationType: type,
      };
      this.$API.wtl_dutyException(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.$TOOLS.closePage();
        this.$router.push({
          path: "/ExceptionManage/ExceptionManage",
          query: {
            isreload: "isreload",
          },
        });
      });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists = array;
    },
    getDetails() {
      this.$API
        .wtl_getExceptionDetail({ exceptionId: this.exceptionId })
        .then((res) => {
          this.baseInForm = res.data.result;
          console.log("this.baseInForm", this.baseInForm);
        });
    },

    initLangeuage() {
      this.contents.editor = {};
      this.contents.editor = new E("#eidtContent_zh-CN");
      this.contents.editor.config.height = 200; //富文本高度
      // 编辑器菜单栏配置
      this.contents.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "indent", //缩进
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      this.contents.editor.create();
    },
  },
};
</script>
<style scoped lang='less'>
// 查询条件边框线
@borderColor: #cccccc;
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  .uploadItem {
    flex: 1;
    display: flex;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.twoInput {
  display: flex;
}
.h3title {
  .titles {
    font-size: 18px;
    font-weight: bold;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid @borderColor;
  font-weight: bold;
  // margin-bottom: 10px;
}

.textArea {
  height: auto !important;
}
.glo_formBox .textArea {
  /deep/ .el-form-item__content {
    height: auto !important;
    z-index: 0;
  }
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ef7c0a;
}
</style>